module.exports = __webpack_public_path__ + "img/gylxt.0f7aafe5.svg";